import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7406c004"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "trade-joinus-main"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "joinus",
  class: "ancho-line"
}, null, -1));
const _hoisted_3 = {
  class: "joinus-box"
};
const _hoisted_4 = {
  class: "join-us-text"
};
const _hoisted_5 = {
  class: "join-us-title"
};
const _hoisted_6 = {
  class: "inner"
};
const _hoisted_7 = {
  class: "join-us-content"
};
const _hoisted_8 = {
  class: "r-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_joinus_form = _resolveComponent("joinus-form");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.joinUsTitle), 1)]), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.joinUsContent), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_joinus_form)])])]);
}